import { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { List, RefreshCw, Settings2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { isAdmin } from "../lib/roles";
import { PageHeader } from "../components/common";
import { BerthSheet } from "../components/BerthSheet";
import { DarsenaSheet, LocaleSheet } from "../components/MarinaSheets";
import { Button } from "../components/ui/button";
import { Sheet, SheetContent, SheetTitle } from "../components/ui/sheet";

import { getToken } from "../lib/api";
const BASE = process.env.REACT_APP_BACKEND_URL;

export function useMapMessages(handlers) {
  useEffect(() => {
    const fn = (e) => {
      if (typeof e.data !== "string") return;
      let msg; try { msg = JSON.parse(e.data); } catch { return; }
      handlers(msg);
    };
    window.addEventListener("message", fn);
    return () => window.removeEventListener("message", fn);
  }, [handlers]);
}

export default function Marina() {
  const { user } = useAuth();
  const [focus, setFocus] = useState("");
  const [key, setKey] = useState(0);
  const [open, setOpen] = useState(null);
  const url = useMemo(() => `${BASE}/api/marina/map-preview?t=${encodeURIComponent(getToken() || "")}&admin=0&focus=${encodeURIComponent(focus)}&v=${Date.now()}_${key}`, [focus, key]);
  const refresh = (pier) => { if (pier !== undefined) setFocus(pier); setKey((k) => k + 1); };

  const onMsg = useCallback((msg) => {
    if (msg.type === "nolink") toast.info("Elemento non ancora collegato");
    else if (msg.type === "info") toast.info(msg.message || "");
    else if (msg.type === "open" && msg.berth_id) setOpen({ kind: "berth", id: String(msg.berth_id) });
    else if (msg.type === "darsena" && msg.berth_id) setOpen({ kind: "darsena", id: String(msg.berth_id) });
    else if (msg.type === "locale" && msg.locale_id) setOpen({ kind: "locale", id: String(msg.locale_id) });
  }, []);
  useMapMessages(onMsg);

  return (
    <div>
      <PageHeader subtitle="Doppio clic su un elemento per aprire la scheda" title="Mappa Porto" actions={<>
        <Button variant="outline" className="rounded-full" onClick={() => refresh()} data-testid="map-refresh-button"><RefreshCw className="w-4 h-4 mr-1" />Aggiorna</Button>
        <Button asChild variant="outline" className="rounded-full" data-testid="map-berths-link"><Link to="/marina/berths"><List className="w-4 h-4 mr-1" />Posti barca</Link></Button>
        {isAdmin(user) && <Button asChild className="rounded-full bg-[var(--navy)]" data-testid="map-admin-link"><Link to="/marina/admin"><Settings2 className="w-4 h-4 mr-1" />Mappa Admin</Link></Button>}</>} />
      <div className="rounded-2xl overflow-hidden border bg-white h-[72vh]">
        <iframe key={url} src={url} title="Mappa porto" className="w-full h-full border-0" data-testid="marina-map-iframe" />
      </div>
      <Sheet open={!!open} onOpenChange={(v) => !v && setOpen(null)}>
        <SheetContent className="w-full sm:max-w-xl overflow-y-auto" data-testid="marina-sheet">
          <SheetTitle className="sr-only">Scheda</SheetTitle>
          {open?.kind === "berth" && <BerthSheet id={open.id} onPresenceSaved={(p) => { setOpen(null); refresh(p || ""); }} />}
          {open?.kind === "darsena" && <DarsenaSheet id={open.id} />}
          {open?.kind === "locale" && <LocaleSheet id={open.id} />}
        </SheetContent>
      </Sheet>
    </div>
  );
}
